var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition-group",
    { attrs: { name: "reorder-transition", tag: "div" } },
    _vm._l(_vm.value, function (item, index) {
      return _c(
        "div",
        { key: item[_vm.itemId], staticClass: "custom-field-container" },
        [
          _c("CustomFieldGeneratorComponent", {
            attrs: { item: item, position: index },
            on: {
              "move-up": _vm.onMoveUp,
              "move-down": _vm.onMoveDown,
              "edit-field": _vm.onEditField,
              "remove-field": _vm.showWarningRemoveDialog,
            },
          }),
          _vm.showButtons
            ? _c("CustomFieldActionButtonsComponent", {
                attrs: {
                  index: index,
                  item: item,
                  fieldsNumber: _vm.value.length,
                },
                on: {
                  "move-up": _vm.onMoveUp,
                  "move-down": _vm.onMoveDown,
                  "edit-field": _vm.onEditField,
                  "remove-field": function ($event) {
                    return _vm.showWarningRemoveDialog(item)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }